import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Reviews from "../pages/reviews/page";
import BeginnerGuide from "../pages/beginner-guide/page";
import AccountOpening from "../pages/account-opening/page";
import Comparison from "../pages/comparison/page";
import Campaign from "../pages/campaign/page";
import Spread from "../pages/spread/page";
import DepositWithdrawal from "../pages/deposit-withdrawal/page";
import AppGuide from "../pages/app-guide/page";
import Safety from "../pages/safety/page";
import Disadvantages from "../pages/disadvantages/page";
import HowToChoose from "../pages/how-to-choose/page";
import FxBasicsPage from "../pages/fx-basics/page";
import LeveragePage from "../pages/leverage/page";
import TradingHoursPage from "../pages/trading-hours/page";
import SupportPage from "../pages/support/page";
import EconomicIndicatorsPage from "../pages/economic-indicators/page";
import FxGuidePage from "../pages/fx-guide/page";
import FxBasicPage from "../pages/fx-basic/page";
import FxTradePage from "../pages/fx-trade/page";
import MinimumAmountPage from "../pages/minimum-amount/page";

const LotGuidePage = lazy(() => import('../pages/lot-guide/page'));
const DemoAccountPage = lazy(() => import('../pages/demo-account/page'));
const FxTaxPage = lazy(() => import('../pages/fx-tax/page'));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/reviews",
    element: <Reviews />,
  },
  {
    path: "/beginner-guide",
    element: <BeginnerGuide />,
  },
  {
    path: "/account-opening",
    element: <AccountOpening />,
  },
  {
    path: "/comparison",
    element: <Comparison />,
  },
  {
    path: "/campaign",
    element: <Campaign />,
  },
  {
    path: "/spread",
    element: <Spread />,
  },
  {
    path: "/deposit-withdrawal",
    element: <DepositWithdrawal />,
  },
  {
    path: "/app-guide",
    element: <AppGuide />,
  },
  {
    path: "/safety",
    element: <Safety />,
  },
  {
    path: "/disadvantages",
    element: <Disadvantages />,
  },
  {
    path: "/how-to-choose",
    element: <HowToChoose />,
  },
  {
    path: "/fx-basics",
    element: <FxBasicsPage />,
  },
  {
    path: "/leverage",
    element: <LeveragePage />,
  },
  {
    path: "/trading-hours",
    element: <TradingHoursPage />,
  },
  {
    path: "/support",
    element: <SupportPage />,
  },
  {
    path: "/economic-indicators",
    element: <EconomicIndicatorsPage />,
  },
  {
    path: "/fx-guide",
    element: <FxGuidePage />,
  },
  {
    path: "/fx-basic",
    element: <FxBasicPage />,
  },
  {
    path: "/fx-trade",
    element: <FxTradePage />,
  },
  {
    path: "/minimum-amount",
    element: <MinimumAmountPage />,
  },
  {
    path: "/lot-guide",
    element: <LotGuidePage />,
  },
  {
    path: "/demo-account",
    element: <DemoAccountPage />,
  },
  {
    path: "/fx-tax",
    element: <FxTaxPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
